import { render, staticRenderFns } from "./CarrierChart.vue?vue&type=template&id=58843170&"
import script from "./CarrierChart.vue?vue&type=script&lang=js&"
export * from "./CarrierChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports